<template>
  <button
    class="relative inline-block text-lgmx_terracota-700 after:absolute after:bottom-0 after:left-0 after:block after:h-px after:w-full after:bg-lgmx_terracota-200"
  >
    <slot />
  </button>
</template>

<script setup></script>
